import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';

import {loadClipByID, loadClipByIDFailure, loadClipByIDSuccess} from './clips.load-by-id.actions';
import {ClipsService} from '../../../services/api/clips/clips.service';
import {Clip} from '../../../services/api/clips/clip.model';


@Injectable()
export class ClipsLoadByIdEffects {

    // noinspection JSUnusedGlobalSymbols
    loadClipById$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadClipByID),
            concatMap((payload: { id: string }) =>
                this.service.getById(payload.id)
                    .pipe(
                        map((data: Clip) => loadClipByIDSuccess({data: data})),
                        catchError(error => of(loadClipByIDFailure({error: error})))
                    )
            )
        );
    });


    constructor(
        private readonly actions$: Actions,
        private readonly service: ClipsService
    ) {
    }

}
